<template>
  <el-dialog
    :visible.sync="show"
    :title="title"
    width="800px"
    :close-on-click-modal="false"
  >
    <el-row :span="24" type="flex" align="middle">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        轮播图标题：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.title"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
      显示位置：
      </el-col>
      <el-col
        :span="16"
      >
        <el-select
          :disabled="isView"
          v-model="detail.locate"
          clearable
        >
          <el-option
            v-for="item in locateOpts"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
      >
      跳转地址：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.url"
          :placeholder="`请输入`"
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        排序：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input-number
          :disabled="isView"
          v-model="detail.sort"
          :min="1"
          :placeholder="`请输入`"
        ></el-input-number>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        上传照片：
        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content">为保证手机端显示效果，请尽量选择500 x 265或等比缩放的图片。</div>
          <i  class="el-icon-question prompt_i"></i>
        </el-tooltip>
      </el-col>
      <el-col
        :span="4"
      >
        <div class="photo-btn" @click="openPicturePicker">
          <i class="el-icon-camera-solid"></i>
        </div>
      </el-col>
      <el-col
        :span="4"
        class="d-flex center"
        v-show="detail.image"
      >
        <el-image
          :src="detail.image"
          class="logo-image"
          :preview-src-list="[ detail.image ]"
        ></el-image>
        <i
          v-if="!isView"
          class="el-icon-delete-solid ml5 fontsize20" 
          style="color: gray; cursor: pointer;"
          @click="delImage"
        ></i>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right"
      >
      备注：
      </el-col>
      <el-col
        :span="16"
      >
        <el-input
          :disabled="isView"
          v-model="detail.remark"
          :placeholder="`请输入`"
          maxlength="20"
          show-word-limit
          clearable
        ></el-input>
      </el-col>
    </el-row>

    <el-row :span="24" type="flex" align="middle" class="mt20">
      <el-col
        :span="4"
        :offset="2"
        class="d-flex right required"
      >
        预定发布时间：
      </el-col>
      <el-col
        :span="16"
      >
        <el-date-picker
          v-model="detail.time" :default-time="['00:00:00','23:59:59']"
          type="datetimerange"
          :range-separator="`至`"
          :start-placeholder="`开始日期`"
          :end-placeholder="`结束日期`"
          value-format="yyyy-MM-dd HH:mm:ss" :picker-options="{
                disabledDate: (date) => {
                  return disabledDate(date)
                }
              }">
        </el-date-picker>
        <!-- <el-date-picker
          :disabled="isView"
          v-model="detail.publish_time"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          :picker-options="{
            disabledDate: (date) => {
              return disabledDate(date)
            }
          }"
          :placeholder="`请选择`">
        </el-date-picker> -->
      </el-col>
    </el-row>


    <div slot="footer" class="d-flex right">
      <el-button
        size="small"
        type="primary"
        @click="publish"
      >发布</el-button>

      <el-button
        size="small"
        @click="close"
      >关闭</el-button>
    </div>

    <PictureSelect ref="pictureSelect" @complete="getPicture" />
  </el-dialog>
</template>

<script>
import {
  mapGetters
} from 'vuex';
import {
  bannerManage
}  from '@/api.js';
import SwiperMixin from '@/mixins/swiper';

export default {
  name: 'EditSwiper',
  mixins: [ SwiperMixin ],
  data() {
    return {
      show: false,
      isView: false,
      detail: {
        id: undefined,
        sort: 1,
        time:[]
      },
    }
  },
  computed: {
    ...mapGetters(['system']),
    mode() {
      // 新建或编辑
      const {
        id
      } = this.detail
      let mode = 'new'; // new or edit
      if (id && Number(id)) {
        mode = 'edit'
      } else {
        mode = 'new'
      }

      return mode
    },
    title() {
      let title = ''
      if (this.mode === 'new') {
        title = `新增`
      } else if (this.mode === 'edit') {
        title = `编辑`
      }

      if (this.isView) {
        title = `详情`
      }

      return title
    }
  },
  methods: {
    reset() {
      this.detail = {
        id: undefined,
        sort: 1,
        time:[]
      }
    },
    async open(config = {}) {
      this.reset()
      const {
        isView,
        detail
      } = config
      this.isView = !!isView

      if (detail && Object.keys(detail).length) {
        // 编辑时
        this.detail = Object.assign({}, detail)
        this.$set(this.detail,'time',[detail.publish_start_time,detail.publish_end_time])
      }

      this.show = true
    },
    validateFields(params) {
      // 校验字段
      const {
        title,
        locate,
        file_id,
        // publish_time,
        publish_start_time,
        publish_end_time,
        sort
      } = params

      let msg = '';
      if (!title || !title.trim()) {
        msg = `标题不可为空`
      } else if (!locate) {
        msg = `位置不可为空`
      } else if (!sort) {
        msg = `排序不可为空`
      } else if (!file_id) {
        msg = `图片不可为空`
      } else if (!publish_end_time || !publish_start_time) {
        msg = `发布时间不可为空`
      }

      if (msg) {
        this.$message.error(msg)
      }

      return !msg
    },
    async publish() {
      const {
        id,
        title,
        locate,
        url,
        remark,
        // publish_time,
        time,
        file_id,
        sort
      } = this.detail

      const params = {
        id,
        title,
        locate,
        file_id,
        url,
        remark,
        // publish_time,
        publish_start_time:time[0] ? time[0] : undefined,
        publish_end_time:time[1] ? time[1] : undefined,
        sort
      }

      const validate = this.validateFields(params)
      if (!validate) return

      const success = await this.save(params)
      if (success) {
        this.$message.success(`操作成功`)
        this.notifyRefresh()
        this.close()
      }
    },
    notifyRefresh() {
      this.$emit('fresh')
    },
    openPicturePicker() {
      if (this.isView) return
      const {
        pictureSelect
      } = this.$refs

      pictureSelect && pictureSelect.show()
    },
    disabledDate(date) {
      // 不可选择的时间范围
      const datetime = this.$moment(date).unix() * 1000
      const { time : now } = this.system
      const todayStart = this.$moment(now).startOf('day')

      return datetime < todayStart
    },
    getPicture(pics) {
      if (!pics || !pics[0]) return

      const {
        fileUrl,
        fileId
      } = pics[0]
    
      this.$set(this.detail, 'image', fileUrl)
      this.$set(this.detail, 'file_id', fileId)
    },
    delImage() {
      this.detail.image = ''
      this.detail.file_id = undefined
    },
    save(params = {}) {
      return this.$request('post', bannerManage, params)
      .then(res => !!res)
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .photo-btn {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: lightgray;
    border-radius: 4px;
    cursor: pointer;
    i {
      color: #fff;
      font-size: 30px;
      vertical-align: middle;
    }
  }
  .logo-image {
    height: 60px;
    width: auto;
  }
</style>